var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "btn",
    {
      staticClass: "btn-loader",
      attrs: {
        type: "primary",
        "native-type": _vm.type,
        size: _vm.size,
        disabled: _vm.disabled || _vm.loaderVisible
      },
      on: { click: _vm.onClick }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.loaderVisible
        ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }